"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Banner;
const react_1 = __importDefault(require("react"));
const HeroBanner_1 = __importDefault(require("./HeroBanner/HeroBanner"));
const DefaultBanner_1 = __importDefault(require("./DefaultBanner/DefaultBanner"));
function Banner(props) {
    if (props.esiType === "broad") {
        return react_1.default.createElement(HeroBanner_1.default, Object.assign({}, props));
    }
    return react_1.default.createElement(DefaultBanner_1.default, Object.assign({}, props));
}
